// Campus photo for /colleges/amherst-college: CC0 1.0, by Carol M. Highsmith, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AThe_1827_Johnson_Chapel_at_Amherst_College%2C_a_private_liberal-arts_college_in_Amherst%2C_Massachusetts%2C_by_Carol_M._Highsmith%2C_2019%2C_from_the_Library_of_Congress_-_master-pnp-highsm-57800-57814a.tif), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/amherst-college/; credited under the photo.
const photo = {
    "slug": "amherst-college",
    "alt": "Johnson Chapel, built in 1827, on the main quad at Amherst College in Amherst, Massachusetts",
    "src": "/colleges/amherst-college/campus-1600.webp",
    "srcSmall": "/colleges/amherst-college/campus-800.webp",
    "srcMid": "/colleges/amherst-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/amherst-college/og.jpg",
    "title": "The 1827 Johnson Chapel at Amherst College, a private liberal-arts college in Amherst, Massachusetts, by Carol M. Highsmith, 2019, from the Library of Congress - master-pnp-highsm-57800-57814a",
    "author": "Carol M. Highsmith",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AThe_1827_Johnson_Chapel_at_Amherst_College%2C_a_private_liberal-arts_college_in_Amherst%2C_Massachusetts%2C_by_Carol_M._Highsmith%2C_2019%2C_from_the_Library_of_Congress_-_master-pnp-highsm-57800-57814a.tif",
    "read": "2026-10-01"
};

export default photo;
